export enum AsyncJobType {
  ImportCandidates = 'import_candidates',
  ImportRevert = 'import_revert',
  CandidateMerge = 'candidate_merge',
  MailboxSend = 'mailbox_send',
  BulkCandidatesAddLocations = 'bulk_candidates_add_locations',
  BulkCandidatesAddTags = 'bulk_candidates_add_tags',
  BulkCandidatesAddTask = 'bulk_candidates_add_task',
  BulkCandidatesAddSources = 'bulk_candidates_add_sources',
  BulkCandidatesFollow = 'bulk_candidates_follow',
  BulkCandidatesUnfollow = 'bulk_candidates_unfollow',
  BulkCandidatesAssign = 'bulk_candidates_assign',
  BulkCandidatesUnassign = 'bulk_candidates_unassign',
  BulkCandidatesDisqualify = 'bulk_candidates_disqualify',
  BulkResendEEODataRequest = 'bulk_resend_eeo_data_request',
  BulkEEODataRequest = 'bulk_eeo_data_request',
  BulkCandidatesRequalify = 'bulk_candidates_requalify',
  BulkCandidatesChangeStage = 'bulk_candidates_change_stage',
  BulkCandidatesDeleteCandidates = 'bulk_candidates_delete_candidates',
  BulkCandidatesSetGdprCustomExpiresAt = 'bulk_candidates_set_gdpr_custom_expires_at',
  BulkCompaniesDeleteMembership = 'bulk_companies_delete_membership',
  BulkCompaniesDeleteInvitation = 'bulk_companies_delete_invitation',
  BulkCompaniesResendInvitation = 'bulk_companies_resend_invitation',
  BulkCompaniesCreateInvitations = 'bulk_companies_create_invitations',
  BrockmeyerCampaignDelete = 'brockmeyer_campaign_delete',
  BulkOffersFollow = 'bulk_offers_follow',
  BulkOffersUnfollow = 'bulk_offers_unfollow',
  BulkOffersEnableReferralProgram = 'bulk_offers_enable_referral_program',
  BulkOffersDisableReferralProgram = 'bulk_offers_disable_referral_program',
  BulkOffersEnableEeo = 'bulk_offers_enable_eeo',
  BulkOffersDisableEeo = 'bulk_offers_disable_eeo',
  BulkOffersDeleteArchived = 'bulk_offers_delete_archived',
  BulkOffersRetrieveArchived = 'bulk_offers_retrieve_archived',
  RemoveSampleData = 'remove_sample_data',
  GenerateSampleData = 'generate_sample_data',
  BulkCandidatesRetrieveCandidates = 'bulk_candidates_retrieve_candidates',
  BulkReferralApplicationsOpen = 'bulk_referral_applications_open',
  BulkReferralApplicationsAccept = 'bulk_referral_applications_accept',
  BulkReferralApplicationsReject = 'bulk_referral_applications_reject',
  AutoConsentCandidatesEmail = 'auto_consent_candidates_email',
  AutoDeleteCandidates = 'auto_delete_candidates',
  BulkContainersDelete = 'bulk_delete_containers',
  BulkRequisitionsFollow = 'bulk_requisitions_follow',
  BulkRequisitionsUnfollow = 'bulk_requisitions_unfollow',
  BulkRequisitionsArchive = 'bulk_requisitions_archive',
  BulkRequisitionsRetrieve = 'bulk_requisitions_retrieve',
  BulkLocationsMerge = 'bulk_locations_merge',
  BulkSharePlacements = 'bulk_placements_share',
  BulkWysiwygEditorSwitch = 'bulk_wysiwyg_editor_switch',
  BulkAssignCandidateMatching = 'bulk_assign_candidate_matching',
  BulkScreenCandidates = 'bulk_screen_candidates',
  BulkRequestEvaluations = 'bulk_request_evaluations',
}

export enum MailboxDeliveryStatus {
  Error = 'error',
  Scheduled = 'scheduled',
  Delivered = 'delivered',
  Blocked = 'blocked',
  New = 'new',
  Quarantined = 'quarantined',
  Pending = 'pending',
}

export interface AsyncJobInfo {
  uuid: string;
  type: AsyncJobType;
}

export interface AsyncJobStartInfo extends AsyncJobInfo {
  total: number;
}

export interface AsyncJobPendingInfo extends AsyncJobStartInfo {
  count: number;
}

export interface AsyncJobFinishedInfo extends AsyncJobInfo {
  errors?: string[];
  payload?: any;
  delivery_statuses?: MailboxDeliveryStatus[];
}
